import React, { Component } from 'react';
import '../../../assets/css/fullcalendar.min.css'
import 'react-big-calendar/lib/less/month.less'
import '../../../assets/css/react-big-calendar.css'
import 'react-big-calendar/lib/less/styles.less'
import FullCalendar from 'fullcalendar-reactwrapper';
import moment from 'moment';
import Modal from 'react-modal'
import { convertTwoDecimalPoint, isRegularLunchOrderType, getNotWorkingDays, getLoginModuleAccess } from "../../../server/util";
import { get } from '../../../server/actions'
import $ from "jquery";
import { MONTH, currency_symbol, MealTypes, MenuOrderTypes } from "../../../server/constants";
import { BeatLoader } from 'react-spinners';
let rowid = 0;

class menuComponent extends Component {
    componentWillMount = () => {
        if (this.props.type === "menu") {
            rowid = this.props.row.original._links.self.href.split('/').pop();
            this.loadMenu(this.props.row)

        }
        else if (this.props.type === "breakfast") {
            rowid = this.props.row.original._links.self.href.split('/').pop();
            this.loadBreakfast(this.props.row)

        }
        else if (this.props.type === "student") {
            let date = this.props.date;
            let mm = (date.getMonth() + 1)
            let yearMonth = (date.getFullYear() + '' + (('0' + mm).slice(-2)))
            console.log('yearMonth', yearMonth)
            this.loadOrderedMenu(this.props.row, yearMonth)
            rowid = this.props.row.original.studentRecId;
        }
    }
    loadMenu = (row) => {
        this.setState({ loading: true });
        let id = row.original._links.self.href.split('/').pop();
        get('/reports/mealsBySummaryId?mealSummaryId=' + id + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.text();
        }).then(data => {
            let meals = eval('(' + data + ')');
            meals.mealMenuItems.forEach(event => {
                if (event.type === "SIDE") {
                    event.start = event.start.addHours(1);
                }
            });
            let parts = row.original.month.split(' ');
            let d = new Date(parts[1], MONTH.indexOf(parts[0]))
            this.setState({ orderedMenu: meals.mealMenuItems, date: d, showCalendar: true, pdfLink: row.original.pdf, loading: false });
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Menu Failed", error)
        })
    }
    loadBreakfast = (row) => {
        this.setState({ loading: true });
        let id = row.original._links.self.href.split('/').pop();
        get('/mealSummaryDetails?menuSummaryId=' + id + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let meals = eval('(' + data.jsonData + ')');
            meals.mealMenuItems.forEach(event => {
                if (event.type === "SIDE") {
                    event.start = event.start.addHours(1);

                }
            });

            let parts = row.original.month.split(' ');
            let d = new Date(parts[1], MONTH.indexOf(parts[0]))
            this.setState({ orderedMenu: meals.mealMenuItems, date: d, loading: false, showCalendar: true, pdfLink: row.original.pdf });
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Menu Failed", error)
        })
    }
    loadOrderedMenu = (row, yearMonth) => {
        console.log('yearMonth', yearMonth)
        this.setState({ loading: true });
        let menuList = [];
        const studentId = row.original.studentRecId;
        let freeStatus = false;
        let reducedStatus = false;
        let isEligForDiscount = false;
        let itemPriceDisForMonthlyOrder = 0;
        // const mType=(this.props.mealType===MealTypes.LUNCH) && !isRegularLunchOrderType(this.props.schoolId||0)?MenuOrderTypes.ITEMIZE:this.props.mealType;
        get('/orderedMealsInfo?studentRecId=' + studentId + '&yearMonth=' + yearMonth + '&menuType=' + this.props.mealType + '&access_token=').then(resp => {
            if (!resp.ok) {
                throw Error(resp.statusText);
            }
            return resp.json();
        }).then(data => {
            if (data) {
                freeStatus = ((data.isStdFreeMealElig || false) ? true : (data.isStdBeforeCare && MealTypes.BREAKFAST == this.props.mealType) ? true : false);
                reducedStatus = data.isStdReducedPriceElig || false;
                isEligForDiscount = data.isEligForDiscount || false;
                itemPriceDisForMonthlyOrder = data.itemPriceDisForMonthlyOrder || 0;
                (data.menuItemsList || []).map(menuItem => {
                    let qty = menuItem.qty || 1
                    let item = {};
                    item.id = menuItem.id;
                    item.title = menuItem.name;

                    item.type = menuItem.type;
                    //item.qty = this.state.isItemized ? ' Qty : '+ (qty) : ''
                    item.qty = ' Qty : ' + (qty);
                    if (menuItem.type === MealTypes.EXTRA) {
                        item.price = (menuItem.price || 0) * qty;
                        item.start = moment(menuItem.start, 'YYYY-MM-DD').set({ "hour": 2 }).toDate();
                    } else {
                        if (menuItem.type === "SIDE") {
                            item.start = moment(menuItem.start, 'YYYY-MM-DD').set({ "hour": 1 }).toDate();
                        }
                        else {
                            item.start = moment(menuItem.start, 'YYYY-MM-DD').set({ "hour": 0 }).toDate();
                            item.isEligForDiscount = isEligForDiscount;
                            item.applyAfterDiscount = (parseFloat(convertTwoDecimalPoint(menuItem.price)) - parseFloat(convertTwoDecimalPoint(itemPriceDisForMonthlyOrder)) * qty);
                        }
                        item.price = (freeStatus ? 0 : (reducedStatus ? (menuItem.reducedPrice || 0) : (item.isEligForDiscount ? item.applyAfterDiscount : (menuItem.price || 0)))) * qty;
                    }
                    menuList.push(item);
                });
                (data.holidayList || []).map(menuItem => {
                    let item = {};
                    item.id = menuItem.id;
                    item.title = menuItem.name;
                    item.type = menuItem.type;
                    item.start = moment(menuItem.start, 'YYYY-MM-DD').set({ "hour": 0 }).toDate();
                    menuList.push(item);
                })

                this.setState({
                    orderedMenu: menuList.sort((i1, i2) => {
                        return i1.type - i2.type;
                    }),
                    date: this.props.date,
                    showCalendar: true,
                    pdfLink: data.pdfLink,
                    loading: false
                })
            } else {
                this.setState({
                    orderedMenu: [],
                    date: this.props.date,
                    showCalendar: true,
                    pdfLink: '',
                    loading: false
                })
            }

        }).catch(
            (error) => {
                console.log('Get Order History response', error)
                this.setState({
                    orderedMenu: [],
                    date: this.props.date,
                    showCalendar: true,
                    pdfLink: ''
                })
            });
    }
    eventStyles = (event, element, view) => {
        if (event.type === "MEAL" || event.type === "ENTREE" ||
            event.type === MealTypes.BREAKFAST.toUpperCase() ||
            event.type === MealTypes.DINNER.toUpperCase() ||
            event.type == MenuOrderTypes.ITEMIZE.toUpperCase() ||
            event.type == MealTypes.SNACK.toUpperCase()) {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                + event.title + " " + event.qty + "  " + currency_symbol(this.props.schoolId || 0) + convertTwoDecimalPoint(event.price) + '</div>');
            //event.color = "#FFB347"; //Em andamento
        }
        else if (event.type === "SIDE") {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: red;font-size: 12px;font-weight: bolder">S :' + " "
                + event.title + " " + event.qty + "  " + currency_symbol(this.props.schoolId || 0) + convertTwoDecimalPoint(event.price) + '</div>');
        }
        else if (event.type === "EXTRA" || event.type === MealTypes.BREAKFAST.toUpperCase() ||
            event.type == MenuOrderTypes.ITEMIZE.toUpperCase() || event.type == MealTypes.SNACK.toUpperCase()) {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: #5cb85c;font-size: 13px;font-weight: bolder">E :' + " "
                + event.title + " " + event.qty + "  " + currency_symbol(this.props.schoolId || 0) + convertTwoDecimalPoint(event.price) + '</div>');
        }
    }

    constructor() {
        super()
        const moduleAccess = getLoginModuleAccess()
        const isItemized = moduleAccess['Menu Order Type'] === 'Itemized' || moduleAccess['Lunch Eligibility type management'] === 'No'

        this.state = {
            orderedMenu: [],
            date: new Date(),
            showCalendar: false,
            pdfLink: '',
            menuItemModalIsOpen: false,
            loading: false,
            isItemized
        }
        this.loadMenu = this.loadMenu.bind(this);
        this.loadBreakfast = this.loadBreakfast.bind(this);

    }


    render() {
        if (!this.state.showCalendar) {
            return (
                <div>
                    <h4>Loading ...</h4>
                </div>
            )
        }
        else {
            return (
                <div>
                    <div className='sweet-loading'
                        style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="row margin-top-10 mr-bt-5 manage-order-pdf-row">

                        <div className="col-md-12 col-sm-12 col-xs-12"><h4
                            className="text-center color-3">{MONTH[this.state.date.getMonth()] + ' ' + this.state.date.getFullYear()}</h4>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="pull-right">
                                <a href={this.state.pdfLink} target="_blank" download>
                                    <button type="button"
                                        className="btn-social btn-linkedin-filled btn-rounded " style={{ border: '0px' }}>
                                        <i class="fa fa-file-pdf-o"></i> Download PDF
                                    </button>
                                </a>
                            </div>


                        </div>
                    </div>

                    <div className="table-responsive mr-bt-10">
                        <FullCalendar
                            id={'your-custom-ID' + rowid}
                            header={false}
                            //weekends={false}
                            hiddenDays={getNotWorkingDays(this.props.schoolId || 0)}
                            editable={false}
                            resizable={false}
                            defaultDate={this.state.date}
                            navLinks={false} // can click day/week names to navigate views
                            eventLimit={false} // allow "more" link when too many events
                            events={this.state.orderedMenu}
                            eventOrder='type'
                            eventRender={this.eventStyles}
                            height={700}
                            eventClick={this.state.canOrder ? this.selectEvent : ''}
                            displayEventTime={false}
                            fixedWeekCount={false}
                        // droppable: true, // this allows things to be dropped onto the calendar
                        />
                    </div>

                </div>
            )
        }
    }
}

export default menuComponent;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/menuComponent.js